/**
 * Phone-width detection shared by the stylesheet and the components
 * (ERIN-8561). Adds `erin-phone` to <html> below the app's phone breakpoint,
 * the hook for the phone layout rules in _shell.scss, and keeps it in step
 * with the viewport. The mobile shell is always phone width, so it gets
 * these rules plus its own `erin-shell` ones.
 */
import { captureShellParams, isMobileShell } from './shell.js';

export const PHONE_QUERY = '(max-width: 767px)';

// The shell marks itself on the start URL (?shell=1&d=…) and/or the user
// agent; the RN shell also adds this class itself. Done here because this
// module is the first thing src/index.js imports.
captureShellParams();
if (typeof document !== 'undefined' && isMobileShell()) {
	document.documentElement.classList.add('erin-shell');
}

const mq =
	typeof window !== 'undefined' && window.matchMedia
		? window.matchMedia(PHONE_QUERY)
		: null;

const apply = () =>
	document.documentElement.classList.toggle('erin-phone', Boolean(mq?.matches));

// Older WebKit (iOS < 14) and system WebViews only have addListener.
export const listenMediaQuery = (list, handler) => {
	if (!list) return () => {};
	if (list.addEventListener) {
		list.addEventListener('change', handler);
		return () => list.removeEventListener('change', handler);
	}

	list.addListener(handler);
	return () => list.removeListener(handler);
};

if (mq) {
	apply();
	listenMediaQuery(mq, apply);
}

export const isPhone = () => Boolean(mq?.matches);

/** Calls back with the new value when the viewport crosses the breakpoint. */
export const onPhoneChange = (callback) =>
	listenMediaQuery(mq, (e) => callback(e.matches));
